import dashboard from '@/views/dashboard/dashboard'

  export default [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: dashboard,
        meta: {
          layout: 'sidebar',
          auth: true,
          heading: 'menu.dashboard'
        }
    }
  ]